import Axios from "axios";
import { ApiBaseUrl, VehicleUrl } from "../config/config";
import { ReferenceKey } from "../models/cartable.model";
import { ApiResultModel } from "../models/common.model";
import { UrlContract } from "../models/vehicle.model";

export const CheckPoliceLetterFile = (
  data: ReferenceKey
): Promise<ApiResultModel<UrlContract>> => {
  return Axios.get<ApiResultModel<UrlContract>>(
    ApiBaseUrl +
    VehicleUrl +
    "/CheckPoliceLetterFile/" +
    data
  ).then((result) => {
    return result.data;
  });
};